"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Function sets the window view height CSS variable to root
 * This is a useful fix to issue of using 100vh traditionally for mobile which has top and bottom bar
 */
var setCSSVarViewHeight = function setCSSVarViewHeight() {
  // 1vh in pixels
  var vh = window.innerHeight * 0.01;

  // Set css variable of new view height to root element
  document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
  return null;
};
var _default = exports["default"] = setCSSVarViewHeight;